import React from 'react';
import { IMediaProps } from './IMediaProps';
import { DocumentIcon } from 'src/components/Icons/DocumentIcon';
import { ImageIcon } from 'src/components/Icons/ImageIcon';
import { AudioIcon } from 'src/components/Icons/AudioIcon';

export const DetailsIcon = ({
	mime_type,
}: Pick<IMediaProps['resource'], 'mime_type'>) => {
	if (mime_type?.includes('image/')) {
		return <ImageIcon className="details__icon" />;
	}

	if (mime_type?.includes('audio/')) {
		return <AudioIcon className="details__icon" />;
	}

	return <DocumentIcon className="details__icon" />;
};
